import getProductSpec from '../../context/getSpec';
import css from './index.module.scss';
import EcoSpecSelector from 'eco-design/sections/eco-spec-selector';
import { Spin } from 'antd';

export default function Support({ productSpecs, theme, title }: any) {
    return (
        <div className={`spec ${css.spec}`}>
            {productSpecs?.items?.length > 0 || productSpecs?.selector?.items?.length > 0 ? (
                <EcoSpecSelector {...productSpecs} />
            ) : (
                <>
                    {getProductSpec(title, theme)}
                    <Spin />
                </>
            )}
        </div>
    );
}
